import { BsMoon } from 'react-icons/bs';
import { HiOutlineSun } from 'react-icons/hi';
import { usePageContentScrollRef } from '../helpers/PageContentScrollContext';

import classes from './PageContent.module.css';
import Sidebar from './Sidebar';

function PageContent({ theme, ThemeToggler, children }) {
  const contentRef = usePageContentScrollRef();
  return (
    <div className={classes.pageContent} >
      <Sidebar />
      <div className={classes.content} ref={contentRef}>
        <div className={classes.subHeader}>
          <div
            className={`${classes.themeToggle}`}
            onClick={() => ThemeToggler()}
          >
            {theme === 'light' ? <BsMoon /> : <HiOutlineSun />}
            <button style={{ cursor: 'pointer' }}>
              {theme === 'light' ? 'Dark ' : 'Light '}
              Mode
            </button>
          </div>
        </div>
        {children}
      </div>
    </div>
  );
}
export default PageContent;
